const MediaTypes = {
  FEED_IMAGE: 'FEED_IMAGE',
  FEED_VIDEO: 'FEED_VIDEO',
  PROFILE_IMAGE: 'PROFILE_IMAGE',
};

export default MediaTypes;
